import React from 'react';
import { flushSync } from 'react-dom';
import ModelInstanceSelector from '../dashboards/components/ModelInstanceSelector';
import businessUnitsService from '../services/business_unit.service';
export const BusinessUnitSelector = _ref => {
  let {
    companyId,
    className = '',
    alreadySelectedInstances = [],
    excludeAlreadySelectedInstances = false,
    onlyActive = false,
    onChange,
    onBlur,
    onSelectInstance,
    eventFieldName,
    searchInputRef
  } = _ref;
  const [,, fetchBusinessUnits] = businessUnitsService.useFetchAll({
    companyId,
    fetchImmediately: false
  });
  const alreadySelectedInstanceIds = new Set(alreadySelectedInstances.map(instance => instance === null || instance === void 0 ? void 0 : instance.id).filter(id => id !== undefined && id !== null));
  const fetchBusinessUnitsByName = async businessUnitName => {
    const businessUnitsResponse = await fetchBusinessUnits();
    const allBusinessUnits = businessUnitsResponse.business_units;
    let filteredBusinessUnits = allBusinessUnits.filter(businessUnit => {
      var _businessUnit$name;
      return (_businessUnit$name = businessUnit.name) === null || _businessUnit$name === void 0 ? void 0 : _businessUnit$name.toLowerCase().includes(businessUnitName === null || businessUnitName === void 0 ? void 0 : businessUnitName.toLowerCase());
    });
    if (onlyActive) {
      filteredBusinessUnits = filteredBusinessUnits.filter(businessUnit => businessUnit.state === 'active');
    }
    if (excludeAlreadySelectedInstances) {
      filteredBusinessUnits = filteredBusinessUnits.filter(businessUnit => !alreadySelectedInstanceIds.has(businessUnit.id));
    }
    return {
      values: filteredBusinessUnits
    };
  };
  const buildEventLikeObject = value => {
    return {
      target: {
        type: 'select',
        value,
        name: eventFieldName
      },
      preventDefault: () => {},
      stopPropagation: () => {},
      stopImmediatePropagation: () => {}
    };
  };
  return /*#__PURE__*/React.createElement(ModelInstanceSelector, {
    className: className,
    allowMultipleSelection: false,
    selectInstances: async businessUnit => {
      const event = buildEventLikeObject(businessUnit.id);
      flushSync(() => {
        onChange(event);
      });
      onBlur(event);
      onSelectInstance && onSelectInstance(businessUnit);
    },
    onSearch: fetchBusinessUnitsByName,
    alreadySelectedInstances: alreadySelectedInstances,
    displayTextKey: 'name',
    searchInputRef: searchInputRef
  });
};
export default BusinessUnitSelector;